import React, { Component } from "react";
import { Container } from "reactstrap";
import homedata from "../../data/home.json";

class Hero extends Component {
  render() {
    const getData = homedata.heroFull;
    const publicUrl = process.env.PUBLIC_URL;

    return (
      <section id="home" className="hero-section-1">
        <Container>
          <div className="john-hero-wrapper">
            <div className="john-hero-image-card">
              <img
                className="john-hero-image"
                src={publicUrl + getData.img}
                alt={getData.title}
              />
            </div>

            <div className="john-hero-content">
              <h1>JOHN 3:16 PAINTING</h1>

              <h2>Commercial and Residential Painting</h2>

              <p className="john-hero-location">
                Proudly serving the Oklahoma City Metro Area
              </p>

              <a href="tel:4053153991" className="john-hero-phone">
                Call us now for a free estimate! (405) 315-3991
              </a>
            </div>
          </div>
        </Container>
      </section>
    );
  }
}

export default Hero;
